import { render, staticRenderFns } from "./PalletInfoPage.vue?vue&type=template&id=36ecb44b&scoped=true&"
import script from "./PalletInfoPage.vue?vue&type=script&lang=js&"
export * from "./PalletInfoPage.vue?vue&type=script&lang=js&"
import style0 from "./PalletInfoPage.vue?vue&type=style&index=0&id=36ecb44b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ecb44b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
